import React from 'react';
import ReactDOM from 'react-dom';
import numeral from 'numeral';
import moment from 'moment-timezone';
import {push, replace, go} from 'connected-react-router';

export function ToString(v) {
    if ((v === null) || (v === undefined)) {
        return '';
    } 
    else if (typeof v.toString === 'function') {
        return v + '';
    }

    return Object.prototype.toString.call(v);
}

export function FormatString(template, ...args){
    const result = ToString(template).replace(/{(\d+)}/g, function(match, number) { 
        return (typeof args[number] != 'undefined')
          ? args[number]
          : match;
      });
    return result;
}

export function EscapeHtml(unsafe) {
    const result =  (unsafe || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/ /g, '&#32;')
        .replace(/\u00A0/g, '&nbsp;');
    
    return result;
}

export function RoundExt(value, precision) {
    const mult = Math.pow(10, parseInt(precision) || 0);
    return Math.round(value * mult) / mult;
}

export function parseNumber(value, precision, min, max) {
    const mn = parseFloat(min);
    const mx = parseFloat(max);
    const decSep = (0.1).toLocaleString()[1];
    
    let strValue = ToString(value).trim().replace(decSep, '.');
    var v = RoundExt(numeral(strValue).value() || 0, precision);
    if (!isNaN(mn)){
        v = Math.max(RoundExt(mn, precision), v);
    }
    if (!isNaN(mx)){
        v = Math.min(RoundExt(mx, precision), v);
    }

    return v;
}

export function ObjectHasProperty(obj, propertyName) {
    return Object.prototype.hasOwnProperty.call(obj, propertyName);
}

export function GetVolumeDiscouintPercent(volume, scale) {
    let result = 0;

    if (Boolean(scale) && (scale.length > 0)) {
        const scaleItem = 
            scale.slice()
                .sort((item1, item2) => item2.MinVolume - item1.MinVolume)
                .find(item => item.MinVolume <= volume);

        if (Boolean(scaleItem)) {
            result = scaleItem.DiscountPercent;
        }
    }

    return result;
}

export function GetSummaryDiscouintPercent(...discountPercents) {
    const result = 100 * (1 - discountPercents.reduce((a, b) => a * (1 - (typeof(b) === 'number' ? b : 0) / 100), 1));

    return result;
}

$(document)
    .on(
        'shown.bs.collapse', 
        '.collapse.autofocuscontent', 
        function(e) {
            e.stopPropagation();
            SetFocusOnFirstFormControl($(this));
        })
    .on(
        'hidden.bs.collapse', 
        '.collapse.autofocuscontent', 
        function(e) {
            e.stopPropagation();
            let $container = $(this).parent();
            const containers = [];
            for(var i = 0; (i < 4) && ($container.length > 0); i++) {
                containers.push($container);
                $container = $container.parent();
            }
            SetFocusOnFirstFormControl(containers);
        });
    
export function SetFocusOnFirstFormControl(container, selectText, includeReadonly) {
    if (!Boolean(container)) {
        return;
    }

    let containers = [];

    if (Array.isArray(container)) {
        containers = container;
    }
    else {
        containers.push(container);
    }

    containers = containers.map(item => {
        if (typeof item === 'string') {
            return $(item);
        } else if (item instanceof React.Component) {
            return $(ReactDOM.findDOMNode(item));
        } else if (item instanceof $) {
            return item;
        }
        return null;
    }).filter(item => Boolean(item));

    if (containers.length == 0) {
        return;
    }

    let selector = ':input:visible:enabled:not(.skipautofocus)';
    if (!Boolean(includeReadonly)){
        selector += ':not([readonly])';
    }
    selector += ', a:visible:not(".disabled"):not(.skipautofocus)';

    const _toArray = (jqCollection) => {
        const r = [];
        r.first = () => r.length > 0 ? $(r[0]) : null;

        jqCollection.each((i, item) => {
            r.push(item);
        });
        return r;
    }

    let $control = null;

    for (var i = 0; (i < containers.length) && !Boolean($control); i++) {
        let $container = containers[i];

        $control = _toArray($container.find(selector)).first();

        if (!Boolean($control)) {
            $control = _toArray($container.find('button:visible:enabled:not(.skipautofocus)')).first();
        }
    }

    if (Boolean($control)) {
        $control.focus();
        if (Boolean(selectText)){
            $control.select();
        }
    }
}

//obsolete
export function GoBackOrRoot1(url) {
    url = ToString(url).trim();

    const href = window.location.href;

	if (Boolean(url)) {
		window.location.assign(url);
	}
	else {
        window.history.go(-1);

        const interval = 50;
        const timeout = 2000;
        let timeElapsed = 0;
        const hInterval = setInterval(function() {
            try
            {
                if (timeElapsed >= timeout) {
                    clearInterval(hInterval);
                    window.location.assign('/');
                }
                else if (href !== window.location.href) {
                    clearInterval(hInterval);
                }
                else {
                    timeElapsed += interval;
                }
            }
            catch(e)
            {
                clearInterval(hInterval);
            }
        },
        interval);
    }
}

function isSameOrigin() {
    let result;

    try {
        result = (new URL(document.referrer)).origin.toLowerCase() == location.origin.toLowerCase();
    }
    catch(e) {
        result = false;
    }
    
    return result;
}

export function GoBackOrRoot(altUrl, dispatch, offset) {

    const url = ToString(altUrl) || '/';

    let delta = parseInt(offset);
    if (isNaN(delta) || (delta >= 0)) {
        delta = -1;
    }

    if ((window.history.length > 1) && isSameOrigin()) {
        if (typeof dispatch === 'function') {
            dispatch(go(delta));
        }
        else {
            window.history.go(delta);
        }
    }
    else if (typeof dispatch === 'function') {
        dispatch(push(url));
    }
    else {
        window.location.assign(url);
    }
}

export function GoToUrlOrRoot(url, dispatch) {
    url = (ToString(url) || '/').trim();
    
    if (typeof dispatch === 'function') {
        dispatch(push(url));
    }
    else {
        window.location.assign(url);
    }
}

function BuildUrl(location) {
    if (typeof location === 'string') {
        return location;
    }
    else if (typeof location === 'object') {
        const {pathname, search, hash} = location;

        let url = (pathname || '/');

        if (Boolean(search) && (search !== '?')) {
            url += (search.charAt(0) === '?') ? search : "?" + search;
        }
    
        if (Boolean(hash) && (hash !== '#')){
            url += (hash.charAt(0) === '#') ? hash : "#" + hash;
        }
    
        return url;
    }

    return null;
}

export function ReplaceUrl(newUrlOrLocation, dispatch) {
    const currentUrl = BuildUrl(location);
    const newUrl = BuildUrl(newUrlOrLocation);
    
    if (newUrl !== currentUrl) {
        if (typeof dispatch === 'function') {
            dispatch(replace(newUrl));
        }
        else if (Boolean(window['history']) && (typeof window['history'].replaceState === 'function')) {
            window.history.replaceState(null, null, newUrl);
        }
        else {
            window.location.assign(newUrl);
        }
    }
}

export function GetErrorsFromResponse(jqXHR, textStatus, errorThrown, requestUrl) {
    const responseJson = {Message: '', ...jqXHR.responseJSON};
    const errors = responseJson.Errors || {All: responseJson.Message || errorThrown || textStatus};

    errors._isNetworkError = (jqXHR.status == 0) && !Boolean(jqXHR.getAllResponseHeaders());

    if (errors._isNetworkError && !Boolean(errors._NetworkErrorMessage)) {
        errors._NetworkErrorMessage = 'Network error occurred';
        if (errors.All == 'error') {
            delete errors.All;
        }
    }
    else if (!errors._isNetworkError && (errors.All == 'error')) {
        errors.All = `Request failed. Status code: ${jqXHR.status}.`;
        if (Boolean(requestUrl)) {
            errors.All += ` Url: ${requestUrl}`;
        }
    }

    return errors;
}

export function GetObjectPropertyValue(obj, propertyName, defaultValue, caseSensitive) {
    propertyName = ToString(propertyName);

    if (Boolean(obj)) {
        if (ObjectHasProperty(obj, propertyName)) {
            return obj[propertyName];
        }

        if (!Boolean(caseSensitive)) {
            for (var key in obj) {
                if (ObjectHasProperty(obj, key) && (key.toLowerCase() == propertyName.toLowerCase())) {
                    return obj[key];
                }
            }
        }
    }

    return defaultValue;
}

export function DeleteObjectProperty(obj, propertyName, caseSensitive) {
    propertyName = ToString(propertyName);

    if (Boolean(obj)) {
        if (ObjectHasProperty(obj, propertyName)) {
            delete obj[propertyName];
        }

        if (!Boolean(caseSensitive)) {
            for (var key in obj) {
                if (ObjectHasProperty(obj, key) && (key.toLowerCase() == propertyName.toLowerCase())) {
                    delete obj[key];
                }
            }
        }
    }
}

export function AssignProperties(dstObj, srcObj, skipArrays) {
    let isChanged = false;
    skipArrays = Boolean(skipArrays);

    if (Boolean(srcObj)) {
        for (var key in dstObj) {
            if (ObjectHasProperty(srcObj, key)) {
                if (skipArrays && (Array.isArray(dstObj[key]) || Array.isArray(srcObj[key]))) {
                    continue;
                }
                const v = srcObj[key];
                if (dstObj[key] !== v) {
                    dstObj[key] = v;
                    isChanged = true;
                }
            }
        }
    }
    
    return isChanged;
}

export function AssignArrayProperty(dstObj, srcObj, propertyName, assignItemFunction, isItemIdEqualsFunction) {
    assignItemFunction = assignItemFunction || AssignProperties;
    isItemIdEqualsFunction = isItemIdEqualsFunction || ((item1, item2) => item1.Id == item2.Id);

    let changed = false;

    if (ObjectHasProperty(srcObj, propertyName)) {
        const oldArray = dstObj[propertyName];
        const newArray = (srcObj[propertyName] || []).slice();
        
        changed = oldArray.length != newArray.length;
        for (var i = 0; i < newArray.length; i++) {
            const newItem = newArray[i];
            const oldItem = oldArray.find((item) => isItemIdEqualsFunction(item, newItem));
            if (!!(oldItem)) {
                if (typeof oldItem === 'object') {
                    newArray[i] = {...oldItem};
                    changed = assignItemFunction(newArray[i], newItem) || changed;
                }
                else {
                    changed = (newArray[i] !== newItem) || changed;
                    newArray[i] = newItem;
                }
            } 
            else {
                changed = true;
            }
        }
        if (changed) {
            dstObj[propertyName] = newArray; 
        }
    }
    return changed;
}

export function DisplaySuccessMessage(message, isHtml) {
    if (!Boolean(isHtml)) {
        AppUtils.DisplaySuccessMessage(EscapeHtml(message));

    }
    else {
        AppUtils.DisplaySuccessMessage(message);
    }
}

export function DisplayErrorMessage(message, isHtml) {
    if (!Boolean(isHtml)) {
        AppUtils.DisplayErrorMessage(EscapeHtml(message));
    }
    else {
        AppUtils.DisplayErrorMessage(message);
    }
}

export function DisplayWarningMessage(message, isHtml) {
    if (!Boolean(isHtml)) {
        AppUtils.DisplayWarningMessage(EscapeHtml(message));
    }
    else {
        AppUtils.DisplayWarningMessage(message);
    }
}

export function PrepareError(error) {
    let result = error;
    if (typeof error === 'string') {
        result = {Error: error || 'Unknown error'}
    }
    else if (error instanceof Error) {
        result = {Error: error.message || 'Unknown error'}
    }

    return result;
}

export function IsErrorsEmpty(errors) {
    const _errors = PrepareError(errors);
    const hasAnyError = 
        Boolean(_errors) &&
        Object.keys(_errors).some(k => Boolean(ToString(_errors[k])));

    return !hasAnyError;
}

export function GetErrorByName(error, errorName) {
    const errors = PrepareError(error);

    const result = Boolean(errors)
        ? errors[errorName] || ''
        : '';

    return result;
}

export function DisplayErrors(errors, title) {
    // const items = [];
    // if (!!(errors)) {
    //     for(var key in errors){
    //         const message = errors[key];
    //         if (message) {
    //             items.push('<div class="text-pre-line">' + message + '</div>');
    //         }
    //     }
    // }

    const _errors = PrepareError(errors);
    const items = Object.keys(_errors || {})
        .filter(k => ['_isCancelled', '_isNetworkError'].indexOf(k) < 0)
        .map(k => ToString(_errors[k]))
        .filter(Boolean)
        .map(e => `<div class="text-pre-line text-break">${EscapeHtml(e)}</div>`);

    if (items.length > 0) {
        let message = (title || '') + '<div>';
        items.forEach(item => message += item);
        message += '</div>';
        
        DisplayErrorMessage(message, true);
    }
}

export function HumanFileSize(size, precision) {
    size = parseInt(size);

    if (isNaN(size)) {
        return '';
    }

    let i = 0;
    size = Math.max(0, size);

    if (size) {
        i = Math.floor(Math.log(Math.abs(size)) / Math.log(1024));
    }
    precision = parseInt(precision);

    let result = '';
    if (!isNaN(precision)) {
        precision = Math.max(0, Math.min(20, precision));
        result = (size / Math.pow(1024, i)).toFixed(precision);
    }
    else {
        result = (size / Math.pow(1024, i)).toFixed(2) * 1;
    }
    result += ' ' + (['B', 'KB', 'MB', 'GB', 'TB'][i] || i);

    return result;
};

let _formCounter = 0;
export function AppendForm(formData, parent) {
    _formCounter++;
    const $parent = Boolean(parent) ? $(parent) : $(document.body);
    const id = `autoform-${_formCounter}`;
    const data = {Method: 'POST', Fields: {}, ...formData};

    const $form = $(`<form id="${id}" method="${data.Method}" action="${data.Action}">"`).appendTo($parent);
    for (var key in data.Fields) {
        if (ObjectHasProperty(data.Fields, key)) {
            $form.append(`<input type="hidden" name="${key}" value="${data.Fields[key]}" />`);
        }
    }
    
    return $form;
}

//const emailTestRegex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
const emailTestRegex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/i;
export function IsEmailStringValid(email) {
    const str = ToString(email).trim();
    emailTestRegex.lastIndex = 0;

    return emailTestRegex.test(str);
}

export function SplitEmailList(list, onlyValid) {
    let result = 
        ToString(list)
            .split(/[\s,;]+/)
            .map(p => p.trim())
            .filter(p => Boolean(onlyValid) ? IsEmailStringValid(p) : Boolean(p));

    return result;
}

//const subdomainTestRegex = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;
//const subdomainTestRegex = /^[a-z0-9]((-(?!-)|[a-z0-9]){0,61}[a-z0-9])?$/i;

export const SubdomainPattern = '((xn--[a-z0-9\\-]{1,58}[a-z0-9])|([a-z0-9]((\\-(?!\\-)|[a-z0-9]){0,61}[a-z0-9])?))';
const subdomainTestRegex = new RegExp(`^${SubdomainPattern}$`, 'i');
export const Ip4AddressPattern = '(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])';

export function IsSubdomainStringValid(subdomain) {
    const str = ToString(subdomain).trim();
    subdomainTestRegex.lastIndex = 0;

    return subdomainTestRegex.test(str);
}

const DomainPattern = `(${SubdomainPattern}\\.)+${SubdomainPattern}`;
const domainTestRegex = new RegExp(`^${DomainPattern}$`, 'i');
const DomainWithPortPattern = `${DomainPattern}(:[1-9][0-9]*)?`;
const domainWithPortTestRegex = new RegExp(`^${DomainWithPortPattern}$`, 'i');

export function IsDomainStringValid(domain, allowPort) {
    const str = ToString(domain).trim();

    if (Boolean(allowPort)) {
        domainWithPortTestRegex.lastIndex = 0;

        return domainWithPortTestRegex.test(str);
    }

    domainTestRegex.lastIndex = 0;

    return domainTestRegex.test(str);
}

//const rootUrlTestRegex = /^(https?\:\/\/)?(([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}|(([0-9]{1,3}\.){3}[0-9]{1,3}))(\:[0-9]+)?$/i;
//const rootUrlTestRegex = /^(https?:\/\/)?([a-z0-9]((\-(?!\-)|[a-z0-9]){0,61}[a-z0-9])?\.){1,}([a-z0-9]((\-(?!\-)|[a-z0-9]){0,61}[a-z0-9])?)(:[0-9]+)?[\/]?$/i;
//const rootUrlTestRegex = new RegExp(`^(https?:\\/\\/)?(${SubdomainPattern}\\.)+${SubdomainPattern}(:[1-9][0-9]*)?\\/?$`, 'i');
const rootUrlTestRegex = new RegExp(`^(https?:\\/\\/)?${DomainWithPortPattern}\\/?$`, 'i');

export function IsRootUrlStringValid(rootUrl) {
    const str = ToString(rootUrl).trim();
    rootUrlTestRegex.lastIndex = 0;

    return rootUrlTestRegex.test(str);
}

const webUrlTestRegex = new RegExp(`^https?:\\/\\/(${SubdomainPattern}\\.)+${SubdomainPattern}(:[1-9][0-9]*)?\\/?`, 'i');
const urlTestRegex = new RegExp(`^https?:\\/\\/(localhost|${Ip4AddressPattern}|(${SubdomainPattern}\\.)+${SubdomainPattern})(:[1-9][0-9]*)?\\/?`, 'i');

export function IsWebUrlStringValid(webUrl) {
    const str = ToString(webUrl).trim();
    webUrlTestRegex.lastIndex = 0;

    return webUrlTestRegex.test(str);
}

export function IsUrlStringValid(url) {
    const str = ToString(url).trim();
    urlTestRegex.lastIndex = 0;

    return urlTestRegex.test(str);
}

const winPathTestRegex  = /^(?:([a-zA-Z]:[\\\/]|\\\\|\/\/))(?:(?:[^\\\/\.\s\:\*\?\"\<\>\|\0\n\r\t]+|[^\\\/\.\s\:\*\?\"\<\>\|\0\n\r\t]+[^\\\/\:\*\?\"\<\>\|\0\n\r\t]*[^\\\/\.\s\:\*\?\"\<\>\|\0\n\r\t]+|[^\\\/\s\:\*\?\"\<\>\|\0\n\r\t]+[^\\\/\.\s\:\*\?\"\<\>\|\0\n\r\t]+)[\\\/])*$/;
//const winPathTestRegex1 = /^((\\\\[a-zA-Z0-9-]+\\[a-zA-Z0-9`~!@#$%^&(){}'._-]+([ ]+[a-zA-Z0-9`~!@#$%^&(){}'._-]+)*)|([a-zA-Z]:))(\\[^ \\/:*?""<>|]+([ ]+[^ \\/:*?""<>|]+)*)*\\?$/;

export function NormalizeWinPathString(path) {
    let str = ToString(path).replace(/[\\\/\s]+$/, '').replace(/\//g, '\\').trim();
    if (Boolean(str)) {
        str += '\\';
    }
    return str;
}

export function IsWinPathStringValid(path) {
    const str = NormalizeWinPathString(path);
    winPathTestRegex.lastIndex = 0;

    return winPathTestRegex.test(str);
}

//const linuxPathTestRegex1 = /^(?:(\/|~\/))([^\/\0]+[\/])*$/;
//const linuxPathTestRegex = /^\/|\/\/|(\/[\w-]+)+$/;
//const linuxPathTestRegex2 = /^\/{1}(((\/{1}\.{1})?[a-zA-Z0-9 ]+\/?)+(\.{1}[a-zA-Z0-9]{2,4})?)$/;

export function NormalizeLinuxPathString(path) {
    // let str = ToString(path).replace(/[\/\s]+$/, '').trim();
    // if (Boolean(ToString(path).trim())) {
    //     str += '/';
    // }
    let str = ToString(path).replace(/[\s]+$/, '').trim();

    return str;
}

export function IsLinuxPathStringValid(path) {
    const str = NormalizeLinuxPathString(path);
    // linuxPathTestRegex.lastIndex = 0;

    // return linuxPathTestRegex.test(str);
    return str.length > 0;
}

export function IsVersionFilterValid(str) {
    return /^([0-9\?\*]{0,3}\.){0,2}[0-9\?\*]{0,3}$/.test(str);
}

export function CreateTimer(interval) {

    const result = new function() {
        const _self = this;
        let _interval = (parseInt(interval) || 0);
        let _timer = 0;
        let _isActive = false;
        let _isLocked = false;

        const _stopTimer = function() {
            if (Boolean(_timer)) {
                clearTimeout(_timer);
                _timer = 0;
            }
        }

        const _startTimer = function() {
            _stopTimer();

            if (!_isLocked && (_interval > 0)) {
                _timer = setTimeout(_onTimer, _interval);
            }
        }

        const _onTimer = function() {
            _stopTimer();
            
            _isLocked = true;

            let isCancel = false;

            try {
                if (typeof _self.onTimer === 'function') {
                    isCancel = Boolean(_self.onTimer());
                }
            }
            finally {
                _isLocked = false;

                if (_isActive && !isCancel) {
                    _startTimer();
                }
                else {
                    _isActive = false;
                }
            }
        }

        const _setInterval = function(newInterval) {
            const interval = parseInt(newInterval) || 0;

            if (_interval != interval) {
                _interval = interval;
                if (_isActive) {
                    _startTimer();
                }
            }
        }

        const _setIsActive = function(newIsActive) {
            const isActive = Boolean(newIsActive);

            if (_isActive != isActive) {
                _isActive = isActive;
                if (_isActive) {
                    _startTimer();
                }
                else {
                    _stopTimer();
                }
            }
        }

        _self.start = function() {
            _startTimer();
            _isActive = true;
        }

        _self.stop = function() {
            _isActive = false;
            _stopTimer();
        }

        Object.defineProperties(
            _self, 
            { 
                'interval': {
                    get: () => _interval,
                    set: (v) => _setInterval(v)
                },
                'isActive': {
                    get: () => _isActive,
                    set: (v) => _setIsActive(v)
                }
            });
    }

    return result;
}

export function NormalizeClassNameString(className) {
    const result = (className || '').split(' ')
        .map(p => p.trim())
        .filter((p, i, a) => Boolean(p) && (a.indexOf(p) == i))
        .join(' ');

    return result;
}

export function QuantityToStringWithMeasure(value, measure, ...excludedValues)
{
    const absValue = Math.abs(parseInt(value) || 0);
    let strValue = excludedValues.some(p => p == value) ? '' : `${value}`;
    let result = '';
    const measures = (measure || '').split(/[,;]/);

    if (measures.length > 2) {
        const measure1 = measures[0];
        const measure2 = measures[1];
        const measure5 = measures[2];

        result = `${strValue}${measure5}`;

        if (absValue < 5 || absValue > 19)
        {
            switch (absValue % 10)
            {
                case 1:
                    result = `${strValue}${measure1}`;
                    break;
                case 2:
                case 3:
                case 4:
                    result = `${strValue}${measure2}`;
                    break;
            }
        }
    }
    else {
        const measureSingle = measures.length > 0 ? measures[0] : '';
        const measureMultiple = measures.length > 1 ? measures[1] : measureSingle;

        if (absValue == 1)
        {
            result = `${strValue}${measureSingle}`;
        }
        else
        {
            result = `${strValue}${measureMultiple}`;
        }
    }

    return result;
}

export function getScreeDPI() {
    let $dpi = $('#screendpitester', document.body);
    if ($dpi.length == 0) {
        $dpi = $('<div id="screendpitester" style="position:absolute;top:-200%;left:-200%;width:1in;height:1in;"></div>').appendTo(document.body);
    }
    return {y: $dpi.outerHeight(), x: $dpi.outerWidth()};
}

export function InitTooltips() {
    if (!Boolean(InitTooltips._alreadyInitialized)) {
        const whiteList = $.fn.tooltip.Constructor.Default.whiteList;
        whiteList.table = [];
        whiteList.tbody = [];
        whiteList.tr = [];
        whiteList.td = [];
        whiteList.th = [];
        whiteList.svg = ['viewbox'];
        whiteList.path = ['d'];
        whiteList.samp = [];
        whiteList.del = [];
        whiteList.ins = [];
        whiteList.var = [];
        whiteList.mark = [];
        whiteList.samp = [];
        whiteList.kbd = [];

        //whiteList.div = ['style'];

        InitTooltips._alreadyInitialized = true;
    }
}

export function WriteConsoleErrors(error, isSilent, isDebugMode) {
    if (Boolean(error)) {
        if (Boolean(isDebugMode) && Boolean(console)) {
            if (typeof console.error === 'function') {
                console.error(error);
            } else if (typeof console.log === 'function') {
                console.log(error);
            }
        }

        if (!Boolean(isSilent)) {
            throw PrepareError(error);
        }
    }
}

export function MakeApiCall(request, fullResponse, cancellationFunction) {
    const promise = new Promise((resolve, reject) => {
        let _cancellationTimer = null;
        let _promiseState = 'pending';
        let isCancelled = false;

        const _stopTimer = () => {
            if (Boolean(_cancellationTimer)) {
                const t = _cancellationTimer;
                _cancellationTimer = null;
                t.stop();
            }
        }

        if (typeof cancellationFunction === 'function') {
            _cancellationTimer = CreateTimer(100);

            _cancellationTimer.onTimer = () => {
                if (_promiseState == 'pending') {
                    const cancellationResult = cancellationFunction();
                    
                    if (Boolean(cancellationResult)) {
                        _stopTimer();
                        if ((typeof request.abort === 'function') &&
                            (request.readyState != 4 /* DONE */)) {
                            //_reject({Cancelled: true});
                            isCancelled = true;
                            request.abort();
                        }
                    }
                } else {
                    _stopTimer();
                }
            }
        }

        const _resolve = (data) => {
            if (_promiseState == 'pending') {
                _stopTimer();
                _promiseState = 'resolved';
                resolve(data);
            }
        }

        const _reject = (data) => {
            if (_promiseState == 'pending') {
                _stopTimer();
                _promiseState = 'rejected';
                reject(data);
            }
        }

        request
            .done(json => {
                _stopTimer();
                if (Boolean(fullResponse)) {
                    _resolve(json);
                }
                else if (Boolean(json.Errors)) {
                    _reject(json.Errors);
                }
                else {
                    _resolve(json.Data);
                }
            })
            .fail(function (qXHR, textStatus, errorThrown) {
                const url = this?.url ?? '';
                _stopTimer();

                const errors = isCancelled
                    ? {_isCancelled: true}
                    : GetErrorsFromResponse(qXHR, textStatus, errorThrown, url);
                
                _reject(errors);
            });
        
        if (Boolean(_cancellationTimer)) {
            _cancellationTimer.start();
        }
    });

    return promise;
}

export function GetMomentTimeZoneName(timeZoneId, flags, timeZoneName) {
    flags = parseInt(flags) || 0;

    let result = '';
    const timeZone = moment.tz.zone(timeZoneId);

    if (Boolean(timeZone)) {
        const dt = moment.utc();
        result = ToString(timeZoneName) || timeZone.name;
        if (Boolean(flags & GetMomentTimeZoneName.FLAG_ADD_UTCOFFSET)) {
            result = `(UTC${dt.tz(timeZoneId).format('Z')}) `.replace(':00', '') + result;
        }
        if (Boolean(flags & GetMomentTimeZoneName.FLAG_ADD_TZ_SHORTNAME)) {
            result = dt.format('z') + ' ' + result;
        }
    }

    return result;
}
GetMomentTimeZoneName.FLAG_ADD_UTCOFFSET = 1;
GetMomentTimeZoneName.FLAG_ADD_TZ_SHORTNAME = 2;

export function FormatDiffAsDuration(milliseconds, params) {
    const _params = {
        appPlusSign: false,
        addMilliseconds: false,
        truncateHours: false,
        truncateMinutes: false,
        ...params
    }
    let ms = parseInt(milliseconds);

    if (isNaN(ms)) {
        return 'Invalid Diff';
    }

    const sign = ms < 0 ? '-' : (Boolean(_params.addPlusSign) ? '+' : '');
    ms = Math.abs(ms);

    const days = Math.floor(ms / 86400000);
    ms -= days * 86400000;
    const hours = Math.floor(ms / 3600000);
    ms -= hours * 3600000;
    const minutes = Math.floor(ms / 60000);
    ms -= minutes * 60000;
    const seconds = Math.floor(ms / 1000);
    ms -= seconds * 1000;

    const _timePartStr = v => ('00' + v).substr(-2);

    let result = sign + (days > 0 ? `${days}d ` : '');
    
    if (!Boolean(_params.truncateHours) || (days != 0) || (hours != 0)) {
        result += `${_timePartStr(hours)}:`;
    }

    if (!Boolean(_params.truncateHours) || !Boolean(_params.truncateMinutes) || (days != 0) || (hours != 0) || (minutes != 0)) {
        result += `${_timePartStr(minutes)}:`;
    }

    result += `${_timePartStr(seconds)}`;

    if (Boolean(_params.addMilliseconds) && (ms != 0)) {
        result += `.${('000' + ms).substr(-3)}`;
    }

    return result;
}

export const GetImageAsDataUrl = (file, maximumImageSize) => {
    const result = new Promise((resolve, reject)  => {
        const fileReader = new FileReader();
        const image = new Image();

        const onImageEvent = e => {
            if (e.type === 'load') {
                let error = '';

                if (!isNaN(maximumImageSize) && (maximumImageSize > 0)) {
                    const width = image.naturalWidth || image.width;
                    const height = image.naturalHeight || image.height;

                    if (width * height > maximumImageSize) {
                        error = `Image size exceeds maximum: ${Math.round(maximumImageSize / 10000) / 100} Megapixel.`;
                    }
                }
                
                if (Boolean(error)) {
                    reject(error);
                }
                else {
                    resolve(fileReader.result);
                }
            }
            else {
                let error = e.target.error;

                if (e.type === 'error') {
                    error = error || `File contains an invalid image. \nFile: "${file.name}"`;
                }

                reject(error);
            }
        }

        const onFileReaderEvent = e => {
            if (e.type === 'load') {
                image.onerror = onImageEvent;
                image.onabort = onImageEvent;
                image.onload = onImageEvent;

                image.src = fileReader.result;
            }
            else {
                let error = e.target.error;

                if (e.type === 'error') {
                    error = error || `File loading error. \nFile: "${file.name}"`;
                }

                reject(error);
            }
        }

        fileReader.onerror = onFileReaderEvent;
        fileReader.onabort = onFileReaderEvent;
        fileReader.onload = onFileReaderEvent;

        fileReader.readAsDataURL(file);
    });

    return result;
}

export const GetFileContentAsText = (file) => {
    const result = new Promise((resolve, reject) => {
        const fileReader = new FileReader();

        const onFileReaderEvent = e => {
            if (e.type === 'load') {
                resolve(fileReader.result);
            }
            else {
                let error = e.target.error;

                if (e.type === 'error') {
                    error = error || `File loading error. \nFile: "${file.name}"`;
                }

                reject(error);
            }
        }

        fileReader.onerror = onFileReaderEvent;
        fileReader.onabort = onFileReaderEvent;
        fileReader.onload = onFileReaderEvent;

        fileReader.readAsText(file);
    });

    return result;
}

export const ObjectToQueryString = (queryData, skipNullOrWhitespace, defaults) => {

    const _skipNullOrWhitespace = Boolean(skipNullOrWhitespace);
    const _defaults = {...defaults};

    const result = Boolean(queryData)
        ? Object.keys(queryData)
            .filter(key => {
                const r =
                    (!_skipNullOrWhitespace || (queryData[key] != null) && (ToString(queryData[key]).trim() != '')) &&
                    (!ObjectHasProperty(_defaults, key) || (queryData[key] != _defaults[key]));

                return r;
            })
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(queryData[key])).join('&')
        : '';

    return result;
}

export const ParseStyles = styleStr => {
    const styleObj = styleStr
        .split(';')
        .map(p => p.split(':'))
        .filter(p => (p.length > 1) && Boolean(p[0]) && Boolean(p[1]))
        .map(p => {
            const n = p[0].trim()
                .replace(/^-ms-/, 'ms-')
                .replace(/-./g, c => c.substr(1).toUpperCase());
            
            return {[n]: p.slice(1).join(':').trim()};
        })
        .reduce((style, p) => ({...style, ...p}), {});
    
    return styleObj;
};

export const PreventDOMLock = f => {
    if (typeof f === 'function') {
        setTimeout(f, 0);
    }
}

export const ParseInt = (s, defaultValue) => {
    let result = parseInt(s);

    return isNaN(result) ? defaultValue : result;
}